import { CreateStripeSubscriptionResponse } from '@aloft/toolkit-shared';
import { useElements, useStripe } from '@stripe/react-stripe-js';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';

import { CheckoutProps } from './types.ts';

type MutationFnParams = {
  stripe: ReturnType<typeof useStripe>;
  elements: ReturnType<typeof useElements>;
  paymentIntentType: CreateStripeSubscriptionResponse['paymentIntentType'];
  clientSecret: CreateStripeSubscriptionResponse['clientSecret'];
  redirectURL: CheckoutProps['redirectURL'];
};

type Props = UseMutationOptions<void, Error, MutationFnParams>;

// This lets us simplify the submit button logic and loading state in the form
export function useConfirmIntent(props?: Props) {
  return useMutation({
    ...props,
    mutationFn: async (params: MutationFnParams) => {
      const { stripe, elements, paymentIntentType, clientSecret, redirectURL } = params;

      if (!stripe || !elements) return;

      const confirmIntent =
        paymentIntentType === 'setup' ? stripe.confirmSetup : stripe.confirmPayment;

      const res = await confirmIntent({
        elements,
        clientSecret: clientSecret,
        redirect: 'if_required',
        confirmParams: {
          return_url: redirectURL,
        },
      });

      if (res.error) {
        throw res.error;
      }
    },
  });
}
